import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Constant = makeShortcode("Constant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Adds a `}<a parentName="p" {...{
          "href": "/api/../api/projects/discountCodes#discountcode"
        }}>{`DiscountCode`}</a>{` to the cart to enable the related `}<a parentName="p" {...{
          "href": "/api/../api/projects/cartDiscounts#cartdiscount"
        }}>{`CartDiscounts`}</a>{`. Adding a Discount Code is only possible if no `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#directdiscount"
        }}>{`DirectDiscount`}</a>{` has been applied to the cart or the order.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addDiscountCode"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`code`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`The `}<inlineCode parentName="li">{`code`}</inlineCode>{` of an existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/discountCodes#discountcode"
          }}>{`DiscountCode`}</a>{`.`}</li>
      </ul>
      <p parentName="section">{`The number of discount codes in a cart is limited to `}<strong parentName="p"><Constant type="limit" name="discountCodesPerCartCount" mdxType="Constant" /></strong>{`.`}</p>
      <p parentName="section">{`Specific Error Codes:`}</p>
      <ul parentName="section">
        <li parentName="ul"><a parentName="li" {...{
            "href": "/api/../api/errors#orders-400-matching-price-not-found"
          }}>{`MatchingPriceNotFound`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      